import { render, staticRenderFns } from "./Background2.vue?vue&type=template&id=2b1e1c60&"
import script from "./Background2.vue?vue&type=script&lang=js&"
export * from "./Background2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports